<div class="appear_anim_3">
  <div class="title">
    <button
      mat-icon-button
      aria-label="Close upload preview"
      (click)="closeMe.emit()"
    >
      <mat-icon>close</mat-icon>
    </button>
    <div>
      Upload
      @if (
        uploader.queue[selectedItemIndex] &&
        uploader.queue[selectedItemIndex].file &&
        uploader.queue[selectedItemIndex].file.type
      ) {
        <span class="lowercase">
          @if (
            uploader.queue[selectedItemIndex].file.type.startsWith(
              "application/pdf"
            )
          ) {
            <span>document</span>
          }
          @if (
            uploader.queue[selectedItemIndex].file.type.startsWith("image/")
          ) {
            <span>photo</span>
          }
          @if (isVideo(uploader.queue[selectedItemIndex])) {
            <span>video</span>
          }
        </span>
      }
    </div>
  </div>

  <div
    class="preview-box"
    celoFileDrop
    [uploader]="uploader"
    (fileOver)="dropZoneState($event)"
    (filesDropped)="handleNewFiles()"
    [ngClass]="{ valid: dropZoneActive === 'valid' }"
  >
    <div class="drop-highlight">
      <div>
        <i class="material-icons icon-xxl">cloud_upload</i>
        <div>UPLOAD</div>
      </div>
    </div>

    @if (!uploader.isUploading) {
      <div class="preview-content">
        @if (uploader.queue && uploader.queue[selectedItemIndex]) {
          <div class="preview">
            @if (isVideo(uploader.queue[selectedItemIndex])) {
              <!-- Videos show their thumbnail while converting, then the converted video. -->
              @let video = videoStateFor(uploader.queue[selectedItemIndex]);
              @if (video?.thumbnailUrl || video?.videoUrl) {
                <div class="media-frame">
                  @if (video.videoUrl) {
                    <video
                      [src]="video.videoUrl"
                      [poster]="video.thumbnailUrl"
                      controls
                    ></video>
                  } @else {
                    <img [src]="video.thumbnailUrl" alt="" />
                  }
                  @if (video.isConverting) {
                    <div class="processing-overlay">
                      <mat-spinner [strokeWidth]="3" [diameter]="36"></mat-spinner>
                      <span>Processing…</span>
                    </div>
                  }
                </div>
              }
            } @else if (picUrlFor(uploader.queue[selectedItemIndex])) {
              <img
                [src]="picUrlFor(uploader.queue[selectedItemIndex])"
                alt=""
              />
            }
            @if (pdfDataFor(uploader.queue[selectedItemIndex])) {
              <pdf-viewer
                [src]="pdfDataFor(uploader.queue[selectedItemIndex])"
                [autoresize]="true"
                [original-size]="false"
                [render-text]="false"
                [zoom]="0.95"
              >
              </pdf-viewer>
            }
          </div>
        }
        <div class="list">
          <div class="tile add-tile">
            <div class="add-button">
              <button mat-icon-button (click)="fileSingle.click()">
                <mat-icon>add</mat-icon>
              </button>
              <input
                [multiple]="true"
                [accept]="
                  type === 'Photos'
                    ? 'image/png, image/jpeg, video/mp4, video/quicktime'
                    : type === 'Documents'
                      ? 'application/pdf'
                      : 'image/png, image/jpeg, video/mp4, video/quicktime, application/pdf'
                "
                #fileSingle
                class="d-none"
                type="file"
                celoFileSelect
                [uploader]="uploader"
                (change)="handleNewFiles()"
              />
            </div>
          </div>
          @for (preview of uploader.queue; track preview; let index = $index) {
            <div (click)="selectedItemIndex = index">
              <div
                class="tile"
                [ngClass]="{ selected: selectedItemIndex === index }"
              >
                @if (picUrlFor(preview)) {
                  <img [src]="picUrlFor(preview)" alt="" />
                }
                @if (isVideo(preview)) {
                  <mat-icon class="video-badge">videocam</mat-icon>
                }
                @if (videoStateFor(preview)?.isConverting) {
                  <div class="tile-processing">
                    <mat-spinner [strokeWidth]="2" [diameter]="18"></mat-spinner>
                  </div>
                }
                @if (pdfDataFor(preview)) {
                  <div class="pdf-tile">
                    <div>
                      {{ index + 1 }}
                    </div>
                  </div>
                }
                <div
                  class="close-button"
                  (click)="removeFile(index); $event.stopPropagation()"
                >
                  <i class="material-icons">close</i>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="description">
          @if (uploader.queue[selectedItemIndex]) {
            <mat-form-field>
              <textarea
                matInput
                [placeholder]="
                  'Add ' + (isInSecureLibrary ? 'description' : 'caption')
                "
                rows="1"
                [(ngModel)]="uploader.queue[selectedItemIndex].description"
              ></textarea>
            </mat-form-field>
          }
          @if (
            uploader.queue[selectedItemIndex] &&
            uploader.queue[selectedItemIndex].file &&
            uploader.queue[selectedItemIndex].file.type &&
            uploader.queue[selectedItemIndex].file.type.startsWith(
              "application/pdf"
            )
          ) {
            <mat-form-field>
              <input
                matInput
                placeholder="Filename"
                rows="1"
                [(ngModel)]="uploader.queue[selectedItemIndex].filename"
              />
            </mat-form-field>
          }
          <button
            mat-button
            class="celo-primary-button"
            (click)="upload()"
            [disabled]="!patientValidity || isConvertingVideo"
            [matTooltip]="
              isConvertingVideo ? 'Waiting for video processing to finish' : ''
            "
          >
            Upload
          </button>
        </div>
        <div class="patient-box">
          <div>
            <div class="details-title">Patient Details</div>
            <div class="details-sub">
              This will be added to all
              @if (
                uploader.queue[selectedItemIndex] &&
                uploader.queue[selectedItemIndex].file &&
                uploader.queue[selectedItemIndex].file.type
              ) {
                <span class="lowercase">
                  @if (
                    uploader.queue[selectedItemIndex].file.type.startsWith(
                      "application/pdf"
                    )
                  ) {
                    <span>documents</span>
                  }
                  @if (
                    uploader.queue[selectedItemIndex].file.type.startsWith(
                      "image/"
                    )
                  ) {
                    <span>photos</span>
                  }
                  @if (isVideo(uploader.queue[selectedItemIndex])) {
                    <span>videos</span>
                  }
                </span>
              }
              you are uploading
            </div>
          </div>
        </div>
        <div class="patient-details-box">
          <div class="patient-details">
            <app-edit-patient
              [patient]="patient"
              [optionalId]="true"
              (validity)="patientValidity = $event"
            ></app-edit-patient>
          </div>
        </div>
        <div #patientDetails></div>
      </div>
    }
    @if (uploader.isUploading) {
      <div class="loading-box">
        <div
          class="spinner-container appear"
          [ngClass]="{ 'appear-now': uploader.isUploading }"
        >
          <mat-spinner [strokeWidth]="3" [diameter]="30"></mat-spinner>
          <div>
            Uploading {{ uploadService.uploadedFiles.length }}/{{
              uploader.queue.length
            }}
          </div>
        </div>
      </div>
    }
  </div>
</div>
